import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useResource } from "@/lib/api";
import EntriesTab from "@/components/directors/EntriesTab";
import AdjustmentsTab from "@/components/directors/AdjustmentsTab";

export default function DirectorAccountsPage() {
  const { data } = useResource("/directors");
  const directors = (data || []).filter((d) => d.active);
  return (
    <div className="rise">
      <h1 className="font-display text-4xl sm:text-5xl font-semibold tracking-tight" data-testid="director-accounts-title">Director accounts</h1>
      <p className="mt-3 text-muted-foreground text-base md:text-lg">One ledger for all directors: Debit for drawings, Credit for money put in or spent personally.</p>
      {data && (
        <Tabs defaultValue="entries" className="mt-8">
          <TabsList className="bg-card border border-border rounded-xl p-1">
            <TabsTrigger value="entries" className="rounded-lg" data-testid="director-tab-entries">Entries</TabsTrigger>
            <TabsTrigger value="adjustments" className="rounded-lg" data-testid="director-tab-adjustments">Adjustments</TabsTrigger>
          </TabsList>
          <TabsContent value="entries" className="mt-6"><EntriesTab directors={directors} /></TabsContent>
          <TabsContent value="adjustments" className="mt-6"><AdjustmentsTab directors={directors} /></TabsContent>
        </Tabs>
      )}
    </div>
  );
}
